import { createFileRoute } from '@tanstack/react-router'
import { PackDetailPage } from '@/features/packs/pack-detail-page'

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/packs/$packSlug'
)({
  component: PackDetailPage,
})
